// extracted by mini-css-extract-plugin
export var asset = "phone_mockup-module--asset--8zrfi";
export var device = "phone_mockup-module--device--q8SuD";
export var phoneMockup = "phone_mockup-module--phoneMockup--lqseo";